/**
 * exp/sub-navbar — anchor menu links, smooth scroll with header offset, and scroll-spy active state.
 */
document.addEventListener( 'DOMContentLoaded', () => {
	const anchorLinksById = new Map();
	let activeAnchorId = '';
	let scrollTicking = false;

	function getScrollOffset() {
		const rootStyles = getComputedStyle( document.documentElement );
		const headerHeight = parseFloat( rootStyles.getPropertyValue( '--header-height' ) ) || 0;
		const subNavbar = document.querySelector( '.exp-sub-navbar' );
		const subNavbarHeight = subNavbar ? subNavbar.offsetHeight : 0;

		return headerHeight + subNavbarHeight;
	}

	function scrollToTarget( targetElement ) {
		if ( ! targetElement ) {
			return;
		}

		window.scrollTo( {
			top: targetElement.getBoundingClientRect().top + window.scrollY - getScrollOffset(),
			behavior: 'smooth',
		} );
	}

	function setActiveLink( anchorId ) {
		if ( anchorId === activeAnchorId ) {
			return;
		}

		activeAnchorId = anchorId;

		anchorLinksById.forEach( ( linkEntry, linkAnchorId ) => {
			const isActive = anchorId !== '' && linkAnchorId === anchorId;

			if ( linkEntry.link ) {
				linkEntry.link.classList.toggle( 'is-active', isActive );

				if ( isActive ) {
					linkEntry.link.setAttribute( 'aria-current', 'location' );
				} else {
					linkEntry.link.removeAttribute( 'aria-current' );
				}
			}

			if ( linkEntry.label ) {
				linkEntry.label.classList.toggle( 'text-primary', isActive );
				linkEntry.label.classList.toggle( 'border-transparent!', isActive );
			}
		} );

		if ( mobileMenu ) {
			if ( anchorId ) {
				mobileMenu.value = '#' + anchorId;
			} else {
				mobileMenu.selectedIndex = 0;
			}
		}
	}

	function getSectionVisibleHeight( anchor ) {
		const rect = anchor.getBoundingClientRect();
		const visibleTop = Math.max( rect.top, 0 );
		const visibleBottom = Math.min( rect.bottom, window.innerHeight );
		return Math.max( 0, visibleBottom - visibleTop );
	}

	function getActiveAnchorId( sectionAnchors ) {
		const visibleSections = [];

		sectionAnchors.forEach( ( anchor ) => {
			const anchorId = anchor.getAttribute( 'id' );

			if ( ! anchorId ) {
				return;
			}

			const visibleHeight = getSectionVisibleHeight( anchor );

			if ( visibleHeight > 0 ) {
				visibleSections.push( {
					anchorId: anchorId,
					visibleHeight: visibleHeight,
				} );
			}
		} );

		if ( ! visibleSections.length ) {
			return '';
		}

		let maxVisibleHeight = 0;

		visibleSections.forEach( ( section ) => {
			if ( section.visibleHeight > maxVisibleHeight ) {
				maxVisibleHeight = section.visibleHeight;
			}
		} );

		const leadingSections = visibleSections.filter( ( section ) => {
			return section.visibleHeight === maxVisibleHeight;
		} );

		if ( leadingSections.length > 1 ) {
			return null;
		}

		return leadingSections[ 0 ].anchorId;
	}

	function syncActiveLink( sectionAnchors ) {
		const nextActiveAnchorId = getActiveAnchorId( sectionAnchors );

		if ( nextActiveAnchorId !== null ) {
			setActiveLink( nextActiveAnchorId );
		}
	}

	const desktopMenu = document.querySelector( '.sub-navbar-menu' );
	const mobileMenu = document.querySelector( '.sub-navbar-select' );

	if ( ! desktopMenu && ! mobileMenu ) {
		return;
	}

	const anchors = Array.from( document.querySelectorAll( '[data-anchor-name]' ) ).filter( ( anchor ) => {
		const anchorName = anchor.getAttribute( 'data-anchor-name' );
		return anchorName !== null && anchorName !== '';
	} );

	anchors.forEach( ( anchor, index ) => {
		const anchorName = anchor.getAttribute( 'data-anchor-name' );
		const anchorId = anchor.getAttribute( 'id' );

		if ( ! anchorName || ! anchorId ) {
			return;
		}

		if ( desktopMenu ) {
			const anchorLink = document.createElement( 'a' );
			anchorLink.setAttribute( 'href', '#' + anchorId );
			anchorLink.setAttribute( 'title', anchorName );
			anchorLink.className = 'group inline-flex items-center justify-center no-underline py-3 lg:py-6';
			if ( index === 0 ) {
				anchorLink.classList.add( 'pe-6' );
			} else {
				anchorLink.classList.add( 'px-6' );
			}

			const anchorLabel = document.createElement( 'span' );
			anchorLabel.className = 'btn-textlink-underline border-gray-lighter! group-hocus:border-transparent!';
			anchorLabel.textContent = anchorName;
			anchorLink.appendChild( anchorLabel );

			anchorLink.addEventListener( 'click', ( event ) => {
				event.preventDefault();
				scrollToTarget( document.getElementById( anchorId ) );
			} );

			anchorLinksById.set( anchorId, {
				link: anchorLink,
				label: anchorLabel,
			} );

			const anchorListItem = document.createElement( 'li' );
			anchorListItem.appendChild( anchorLink );
			desktopMenu.appendChild( anchorListItem );
		}

		if ( mobileMenu ) {
			const mobileAnchorLink = document.createElement( 'option' );
			mobileAnchorLink.setAttribute( 'value', '#' + anchorId );
			mobileAnchorLink.textContent = anchorName;
			mobileMenu.appendChild( mobileAnchorLink );
		}
	} );

	if ( mobileMenu ) {
		mobileMenu.addEventListener( 'change', ( event ) => {
			const selectedValue = event.target.value;
			const selectedIndex = event.target.selectedIndex;

			if ( selectedIndex > 0 && selectedValue && selectedValue.indexOf( '#' ) === 0 ) {
				const targetId = selectedValue.substring( 1 );
				scrollToTarget( document.getElementById( targetId ) );
			}
		} );
	}

	if ( anchors.length ) {
		syncActiveLink( anchors );

		window.addEventListener(
			'scroll',
			() => {
				if ( scrollTicking ) {
					return;
				}

				scrollTicking = true;

				window.requestAnimationFrame( () => {
					syncActiveLink( anchors );
					scrollTicking = false;
				} );
			},
			{ passive: true }
		);

		window.addEventListener( 'resize', () => {
			syncActiveLink( anchors );
		} );
	}
} );
